exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#topPanel{position:absolute;top:20px;width:280px;left:-o-calc(50% - 140px)!important;left:calc(50% - 140px)!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /~/css-loader!/~/postcss-loader!/src/views/WarningsView.css
// module id = 1997
// module chunks = 0